import styled from "styled-components";

export const TextArea = styled.textarea`
  font-family: "flama";
  resize: none;
  height: 160px;
  padding: 14px;
  border: none;
  border: 1px solid ${(props) => props.theme.colors.typography1.dark};
  border-radius: 12px;
  margin-bottom: 28px;
  background-color: inherit;
  color: ${(props) => props.theme.colors.typography1.dark};
  font-size: 0.89rem;
  outline: none;

  :focus {
    border: 1.5px solid ${(props) => props.theme.colors.brand1.pure};
  }

  :disabled {
    cursor: not-allowed;
  }

  @media (min-width: 768px) {
    height: 96px;
  }
`;